export const levelUpModalInfo = {
  1: {
    imageCssClass: 'lvl_1',
    title: 'home_modals_level_up_title_pt2_level_1',
    description: 'home_modals_level_up_description_level_1'
  },
  2: {
    imageCssClass: 'lvl_2',
    title: 'home_modals_level_up_title_pt2_level_2',
    description: 'home_modals_level_up_description_level_2'
  },
  3: {
    imageCssClass: 'lvl_3',
    title: 'home_modals_level_up_title_pt2_level_3',
    description: 'home_modals_level_up_description_level_3'
  },
  4: {
    imageCssClass: 'lvl_4',
    title: 'home_modals_level_up_title_pt2_level_4',
    description: 'home_modals_level_up_description_level_4'
  }
}



// WEBPACK FOOTER //
// ./src/constants/level.js